/**
 * Read-only text evidence when screening has no document PDF path (e.g. FHIR-only atoms).
 */

import { hasTextScreeningEvidence } from "./viewEvidenceTypes";

/** Props for the text-only evidence pane in View Evidence. */
export interface TextEvidencePanelProps {
  source?: string | null;
  decidingFact?: string | null;
}

/**
 * Render agent source and deciding fact when no authenticated PDF is available.
 *
 * @param props - Atom-level source and deciding fact from screening
 * @returns Text evidence layout, or null when both fields are empty
 */
export function TextEvidencePanel({
  source,
  decidingFact,
}: TextEvidencePanelProps) {
  if (!hasTextScreeningEvidence(source, decidingFact)) {
    return null;
  }

  const sourceText = source?.trim();
  const factText = decidingFact?.trim();

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto p-6">
      {sourceText ? (
        <div className="flex flex-col gap-2">
          <div className="text-overline font-semibold uppercase tracking-[0.0625rem] text-primaryGray-8">
            Source
          </div>
          <p className="whitespace-pre-wrap text-sm leading-5 text-primaryGray-1">
            {sourceText}
          </p>
        </div>
      ) : null}
      {factText ? (
        <div className="flex flex-col gap-2">
          <div className="text-overline font-semibold uppercase tracking-[0.0625rem] text-primaryGray-8">
            Deciding fact
          </div>
          <p className="whitespace-pre-wrap text-sm leading-5 text-primaryGray-1">
            {factText}
          </p>
        </div>
      ) : null}
    </div>
  );
}
